module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-29_APRILE-OK-bd6f9bf83f52292012e644842d7750ee.png";